module.exports = __webpack_public_path__ + "static/media/dropimages-icon.d69cc794.svg";